import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { EDITOR_VIEW_NAME, PROJECT_COORDINATES } from "../core/constants";
import { translate } from "../core/i18n";
import { store } from "../core/state";
import { getViewData } from "../core/views";


export const ProjectCoordinates = () => {
  const [coords] = store.useState(PROJECT_COORDINATES);
  if (getViewData(EDITOR_VIEW_NAME).cfg?.editorFeatures?.showIframeCoordinates === false) return null;

  const text = ` ${translate("view-editor-coordinates")} X: ${coords.x || 0} Y:${coords.y || 0}`
  return (
    <div className="coordinates" id="submenu">
      <span className="input-group-text"><FontAwesomeIcon icon="compass" />&nbsp;{text}</span>
    </div>
  );
}
